import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { MuiButtonSpacingType } from '../../types/styles';
import { Helmet } from 'react-helmet-async';

import { Button as MuiButton, Typography } from '@mui/material';
import { spacing } from '@mui/system';

const Button = styled(MuiButton)<MuiButtonSpacingType>(spacing);

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(8)}px;
  text-align: center;
  background: ${(props) => (props.theme.palette.mode === 'dark' ? '#141414' : '#ffffff')};
  border: 1px solid ${(props) => (props.theme.palette.mode === 'dark' ? '#1f1f1f' : '#e5e5e5')};
  border-radius: 12px;
  box-shadow: none;
  max-width: 600px;
  margin: 0 auto;

  ${(props) => props.theme.breakpoints.up('md')} {
    padding: ${(props) => props.theme.spacing(12)}px;
  }
`;

function Page500() {
  return (
    <Wrapper>
      <Helmet title="500 Error" />
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        500
      </Typography>
      <Typography component="h2" variant="h5" align="center" gutterBottom>
        Internal server error.
      </Typography>
      <Typography component="h2" variant="body1" align="center" gutterBottom>
        The server encountered something unexpected that didn&apos;t allow it to complete the
        request.
      </Typography>

      <Button component={Link} to="/" variant="contained" color="secondary" mt={2}>
        Return to website
      </Button>
    </Wrapper>
  );
}

export default Page500;
